import { PushpinOutlined, PushpinTwoTone } from '@ant-design/icons';
import style from './chatPill.module.css';
import { Popconfirm, Tooltip } from 'antd';
import { on } from 'events';

export function ChatPill(props: any) {
    let { userPill, text, pinned, onPin } = props;
    return (
        <div className={`${style.chatPill} ${userPill ? style.userPill : style.assistantPill} `} style={{ position: 'relative' }}>
            <div dangerouslySetInnerHTML={{ __html: text }} style={{overflowX: 'auto'}}/>
            {!userPill && (pinned ?
                <Popconfirm
                    title="Remove Saved Message"
                    description="Are you sure to remove this from saved messages?"
                    onConfirm={onPin}
                    // onCancel={cancel}
                    okText="Yes"
                    cancelText="No"
                >
                    <span style={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        cursor: 'pointer',
                    }}>
                        <PushpinTwoTone />
                    </span>
                </Popconfirm> :
                <Tooltip title={"Save"} placement="left">
                    <span style={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        cursor: 'pointer',
                    }} onClick={onPin}>
                        <PushpinOutlined style={{ transform: 'rotate(45deg)' }} />
                    </span>
                </Tooltip>)
            }
        </div>
    );
}

export function ChatEnquiringPill(props: any) {
    let text = "Analysing your data to get insights...";
    return (
        <div className={`${style.chatPill} ${style.assistantPill} ${style.reflectionAnimation}`}
            dangerouslySetInnerHTML={{ __html: text }}>
        </div>
    );
}
